import { useEffect, useState } from "react";
import { CloudDownload, Plus, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "../api";
import { useAuth } from "../auth";

export default function RatesPanel({ onChange }) {
  const { can } = useAuth();
  const editable = can("admin", "finance");
  const [rates, setRates] = useState([]);
  const [form, setForm] = useState({ date: new Date().toISOString().slice(0, 10), usd_try: "", eur_try: "" });
  const [busy, setBusy] = useState(false);

  const load = () => api.get("/rates").then((r) => setRates(r.data.rates)).catch(() => {});
  useEffect(() => { load(); }, []);

  const save = async (e) => {
    e.preventDefault();
    try {
      await api.post("/rates", { ...form, usd_try: Number(form.usd_try), eur_try: Number(form.eur_try), source: "manual" });
      toast.success("Kur kaydedildi"); setForm({ ...form, usd_try: "", eur_try: "" }); load(); onChange?.();
    } catch (err) { toast.error(errMsg(err)); }
  };
  const fetchTcmb = async () => {
    setBusy(true);
    try { const r = await api.post("/rates/fetch", { date: form.date }); toast.success(`TCMB kuru alındı (${r.data.date})`); load(); onChange?.(); }
    catch (err) { toast.error(errMsg(err, "Kur servisine ulaşılamadı")); }
    finally { setBusy(false); }
  };
  const remove = async (id) => { await api.delete(`/rates/${id}`); load(); onChange?.(); };

  return (
    <section className="panel" data-testid="rates-panel">
      <div className="panel-head">
        <div><span className="eyebrow">KUR YÖNETİMİ</span><h2>Tarih bazlı döviz kurları (₺ karşılığı)</h2><small className="rate-note">TCMB Döviz Alış–Döviz Satış ortalaması</small></div>
        {editable && <button className="import-btn" onClick={fetchTcmb} disabled={busy} data-testid="fetch-rate-button"><CloudDownload size={15} /> {busy ? "Alınıyor…" : "TCMB'den çek"}</button>}
      </div>
      {editable && (
        <form className="inline-form" onSubmit={save} data-testid="rate-form">
          <input type="date" required value={form.date} onChange={(e) => setForm({ ...form, date: e.target.value })} data-testid="rate-date-input" />
          <input type="number" step="0.0001" required placeholder="1 USD = ? ₺" value={form.usd_try} onChange={(e) => setForm({ ...form, usd_try: e.target.value })} data-testid="rate-usd-input" />
          <input type="number" step="0.0001" required placeholder="1 EUR = ? ₺" value={form.eur_try} onChange={(e) => setForm({ ...form, eur_try: e.target.value })} data-testid="rate-eur-input" />
          <button className="new-btn" data-testid="save-rate-button"><Plus size={14} /> Kaydet</button>
        </form>
      )}
      <div className="project-table">
        <div className="table-row table-head rate-row"><span>TARİH</span><span>USD/TRY</span><span>EUR/TRY</span><span>KAYNAK</span><span></span></div>
        {rates.map((r, i) => (
          <div className="table-row rate-row" key={r.id} data-testid={`rate-row-${i}`}>
            <b className="mono-small">{r.date}</b><span className="mono-small">{r.usd_try}</span><span className="mono-small">{r.eur_try}</span>
            <span><em className={`status ${r.source === "manual" ? "status-blue" : "status-green"}`}>{r.source === "manual" ? "Manuel" : r.source}</em></span>
            {editable ? <button className="row-action danger" onClick={() => remove(r.id)} data-testid={`delete-rate-${i}`}><Trash2 size={13} /></button> : <span />}
          </div>
        ))}
        {!rates.length && <div className="empty-hint">Henüz kur girilmemiş. Konsolide KPI'lar için en az bir kur girin.</div>}
      </div>
    </section>
  );
}
